<template>
  <div v-if="loaded" class="contract-index">
    <template v-if="alertEditbox">
      <div class="con-list-wrap z_regCon pad30-t pad35_l">
        <ul>
          <li class="clearfix mar20_b">
            <label class="pad30_r pull-left "><em class="red">*</em>合同模板名称</label>
            <div class="pull-left ">
              <el-input v-model="name" maxlength="30" :disabled="isDefault && transferAttrId" class="selt w200"
                placeholder="请填写合同模板名称"></el-input>
            </div>
          </li>
        </ul>
        <!--直营合同页面-->
        <template v-if="templateMethodSel == 'ZY-NXKH' || templateMethodSel == 'XS-KLMY' || templateMethodSel == 'XS-YR'">
          <ul>
            <li class="clearfix mar20_b pad10-l">产品（货物）型号、数量、金额</li>
            <li class="clearfix mar20_b">
              短溢量：±
              <el-input-number controls-position="right" size="small" :precision="2" :step="1" :min="0.01" :max="100"
                class="w80 mar5 dpad5" v-model="attrVal.contract22"></el-input-number>%，
              在此范围内根据实际交货数量及约定销售单价计算最终合同价款
            </li>
            <li class="clearfix flex mar20_b">
              产品质量标准：
              <div>
                每一批次产品、货物的质量标准按以下选项约定验收，无明确规定的按照国家相关标准或农信平台规则执行：
                <div></div>
                <el-radio-group v-model="attrVal.contract58">
                  <el-radio label="1" key="1">
                    （1）按照标签所示质量标准。
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio class="checkbox-top2" label="2" key="2">
                    （2）双方约定的质量标准
                    <div></div>
                    <el-input class="mar5-t" style="width: 500px" type="textarea" placeholder="请输入内容"
                      v-model="attrVal.contract60" :maxlength="200" show-word-limit></el-input>
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio label="3" key="3">
                    （3）按照农信商城店铺商品详情页列明的标准执行。
                  </el-radio>
                </el-radio-group>

                <div>赔付与拒收的标准</div>
                <el-input style="width: 500px" type="textarea" placeholder="请输入内容" v-model="attrVal.contract23"
                  :maxlength="200" show-word-limit></el-input>
              </div>
            </li>
            <li class="clearfix flex mar20_b">
              交 付：
              <div>
                由甲方向乙方指定下游客户交付，甲乙双方一致选择以下选项约定进行交付：
                <div></div>
                <el-radio-group v-model="attrVal.contract41">
                  <el-radio label="1" key="1">
                    （1）本合同签订后<el-input-number controls-position="right" size="small" :precision="2" :step="1"
                      :min="0.01" :max="300" class="w80 mar5 dpad5" v-model="attrVal.contractData1">
                    </el-input-number>日内，甲方向乙方指定的地点和收货人发货。
                  </el-radio>
                  <div></div>
                  <el-radio label="2" key="2">（2）甲方收到乙方100%货款后<el-input-number controls-position="right" size="small"
                      :precision="2" :step="1" :min="0.01" :max="100" class="w80 mar5 dpad5"
                      v-model="attrVal.contractData3"></el-input-number>日内，向乙方指定的地点和收货人发货。
                  </el-radio>
                  <div></div>
                  <template v-if="templateMethodSel == 'XS-YR' || templateMethodSel == 'XS-KLMY'">
                    <el-radio label="3" key="3">
                      （3）其他交付方式：
                    </el-radio>
                    <div class="mar10-t"></div>
                    <el-input style="width: 552px" type="textarea" placeholder="请输入内容" v-model="attrVal.contract53"
                      :maxlength="200" show-word-limit></el-input>
                  </template>
                  <template v-else>
                    <el-radio label="3" key="3">
                      （3）约定的交货期间：从<el-input class="selt w200" v-model="attrVal.contract66"
                      maxlength="11" ></el-input> 到<el-input class="selt w200" v-model="attrVal.contract67"
                      maxlength="11" ></el-input>，这此期间，由甲方提前<el-input-number controls-position="right" size="small" :step="1"
                    :min="0" :max="300" class="w80 mar5 dpad5" v-model="attrVal.contract68">
                  </el-input-number>天通知乙方提货或分期提货。
                    </el-radio>
                    <div class="mar10-t"></div>
                    <el-radio label="4" key="4">
                      （4）其他交付方式：
                    </el-radio>
                    <div class="mar10-t"></div>
                    <el-input style="width: 552px" type="textarea" placeholder="请输入内容" v-model="attrVal.contract53"
                      :maxlength="200" show-word-limit></el-input>
                  </template>
                </el-radio-group>
                <div class="mar20-t">
                  交货方式及运费承担：采用选择以下选项方式交货<font class="red">（默认获取订单配送方式）</font>
                </div>
                <el-radio-group v-model="attrVal.contract18">
                  <el-radio label="1" key="1">
                    （1）甲方直接送货或委托第三方送货，该商品自送到乙方指定地点并由指定接收人或下单人签收的（指在电子签署单上签收或在订单上确认收货），视为乙方收货完成，甲方委托第三方快递公司配送的，自配送到乙方指定地点的，视为乙方收货完成，其相关的运费由甲方承担。
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio label="2" key="2">
                    （2）乙方指定人员上门提货，自乙方指定人员或下单人员签署电子签收单或通过农信商城确认收货的，视为乙方收货完成，运费由乙方承担。
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio label="3" key="3">
                    （3）其他方式
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-input style="width: 552px" type="textarea" placeholder="请输入内容" v-model="attrVal.contract61"
                    :maxlength="200" show-word-limit></el-input>
                </el-radio-group>
              </div>
            </li>
            <li class="clearfix flex mar20_b">
              <div class="nowrap">产品验收：</div>
              <div>
                <div>
                  乙方应按平台规定的交易流程进行确认收货，按平台交易规定确认收货后则视为乙方已经收到货物，乙方在确认收货后
                  <el-input-number controls-position="right" size="small" :precision="2" :step="1" :min="0.01"
                    :max="300" class="w80 mar5 dpad5" v-model="attrVal.contract33"></el-input-number>
                    日内，应及时查验商品数量及质量，如发现数量及质量有问题的，应及时通过平台订单“售后”系统，向甲方及平台方提出书面异议，超过
                  <el-input-number controls-position="right" size="small" :precision="2" :step="1"
                    :min="0.01" :max="300" class="w80 mar5 dpad5" v-model="attrVal.contract34"></el-input-number>
                    日未提出书面异议的，则视为乙方收到的货物质量合格。甲方有权申请按照平台规则进行结算支付货款
                </div>
              </div>
            </li>
            <li class="clearfix flex mar20_b">

              <div class="nowrap">货款结算：</div>
              <div>
                结算与付款方式：根据农信平台支付规则进行线上支付结算，甲乙双方一致选择以下选项结算方式
                <div></div>
                <el-radio-group v-model="attrVal.contract40">
                  <el-radio label="1" key="1">
                    （1）先款后货，乙方在本合同签订<el-input-number controls-position="right" size="small" :precision="2"
                      :step="1" :min="0.01" :max="300" class="w80 mar5 dpad5"
                      v-model="attrVal.contractData4"></el-input-number>天内，通过农信商城平台先行全额预付或结算给甲方款项，乙方可一次性或分批提货，多余部分由甲方通过平台退还。
                  </el-radio>
                  <div></div>
                  <el-radio label="2" key="2">
                    （2）货到付款，乙方或指定收货人对该订单或批次货物验收合格并确认收货后（签署电子签收单）<el-input-number controls-position="right" size="small"
                      :precision="2" :step="1" :min="0.01" :max="300" class="w80 mar5 dpad5"
                      v-model="attrVal.contractData15"></el-input-number>日内，乙方将全部货款通过平台结算给甲方。
                  </el-radio>
                  <div></div>
                  <el-radio label="3" key="3">
                    （3）分次付款，本合同签署后<el-input-number controls-position="right" size="small" :precision="2" :step="1"
                      :min="0.01" :max="300" class="w80 mar5 dpad5"
                      v-model="attrVal.contractData5"></el-input-number>日内乙方付<el-input-number controls-position="right"
                      size="small" :precision="2" :step="1" :min="0.01" :max="100" class="w80 mar5 dpad5"
                      v-model="attrVal.contractData6"></el-input-number>%款项，产品、货物装车/装船后当日内乙方付<el-input-number
                      controls-position="right" size="small" :precision="2" :step="1" :min="0.01" :max="100"
                      class="w80 mar5 dpad5"
                      v-model="attrVal.contractData7"></el-input-number>%款项，</br>乙方指定收货人确认收货后<el-input-number
                      controls-position="right" size="small" :precision="2" :step="1" :min="0.01" :max="300"
                      class="w80 mar5 dpad5" v-model="attrVal.contractData8"></el-input-number>日内乙方付<el-input-number
                      controls-position="right" size="small" :precision="2" :step="1" :min="0.01" :max="100"
                      class="w80 mar5 dpad5" v-model="attrVal.contractData9"></el-input-number>%款项
                  </el-radio>
                  <div></div>
                  <el-radio class="checkbox-top" label="4" key="4">
                    （4）先验后款，乙方指定收货人收到货物后（签署电子签收单）并验收合格后的<el-input-number controls-position="right" size="small" :step="1"
                      :min="0" :max="300" class="w80 mar5 dpad5"
                      v-model="attrVal.contract72"></el-input-number>日内通过平台将全款结算给甲方。
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio class="checkbox-top" label="5" key="5">
                    （5）限定天数结算。乙方应在甲方发货后<el-input-number controls-position="right" size="small" :precision="2" :step="1"
                      :min="0.01" :max="300" class="w80 mar5 dpad5"
                      v-model="attrVal.contractData14"></el-input-number>日内将全部货款通过平台结算给甲方。
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio class="checkbox-top" label="6" key="6">
                    （6）按发货进度付款：合同签订后<el-input-number controls-position="right" size="small" :step="1"
                      :min="0" :max="300" class="w80 mar5 dpad5"
                      v-model="attrVal.contract73"></el-input-number>日内支付合同总额的<el-input-number
                      controls-position="right" size="small" :precision="2" :step="1" :min="0.01" :max="100"
                      class="w80 mar5 dpad5" v-model="attrVal.contract74"></el-input-number>%作为定金即
                      <el-input-number controls-position="right" size="small" :precision="2" :step="1"
                      :min="0.01" class="w200 mar5 dpad5"
                      v-model="attrVal.contract75"></el-input-number>元，剩余货款在每次提货前支付，</br>已支付定金在需方最后一次提货时转为货款结算。
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio class="checkbox-top" label="7" key="7">
                    （7）固定时间节点结算，乙方于每月<el-input-number controls-position="right" size="small" :precision="2" :step="1"
                      :min="0.01" :max="300" class="w80 mar5 dpad5"
                      v-model="attrVal.contractData11"></el-input-number>日将指定收货人验收合格并确认收货但未结算的货款通过平台结算给甲方。
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio label="8" key="8">
                    （8）其他结算方式
                  </el-radio>
                </el-radio-group>
                <div class="mar10-t"></div>
                <el-input style="width: 528px" type="textarea" placeholder="请输入内容" v-model="attrVal.contract54"
                  :maxlength="200" show-word-limit></el-input>
              </div>
            </li>
            <li class="clearfix flex mar20_b">
              违约责任：
              <div>
                特别约定
                <div></div>
                <el-input style="width: 528px" type="textarea" placeholder="请输入内容" v-model="attrVal.contract25"
                  :maxlength="200" show-word-limit></el-input>
              </div>
            </li>
            <li class="clearfix flex pad10-l mar20_b">
              补充条款：
              <div>
                <el-input style="width: 528px" type="textarea" placeholder="请输入内容" v-model="attrVal.contract26"
                  :maxlength="200" show-word-limit></el-input>
              </div>
            </li>
          </ul>
        </template>

        <!--代采合同-->
        <template v-else-if="templateMethodSel == 'CG-NXKH'|| templateMethodSel == 'CG-KLMY'|| templateMethodSel == 'CG-YR'">
          <ul>
            <li class="clearfix mar20_b pad10-l">产品（货物）型号、数量、金额</li>
            <li class="clearfix mar20_b">
              短溢量：±
              <el-input-number controls-position="right" size="small" :precision="2" :step="1" :min="0.01" :max="100"
                class="w80 mar5 dpad5" v-model="attrVal.contract22"></el-input-number>%，在此范围内根据实际交货数量及约定销售单价计算最终合同价款
            </li>
            <li class="clearfix flex mar20_b">
              产品质量标准：
              <div>
                每一批次产品、货物的质量标准按以下选项约定验收，无明确规定的按照国家相关标准或农信平台规则执行：
                <div></div>
                <el-radio-group v-model="attrVal.contract58">
                  <el-radio label="1" key="1">
                    （1）按照标签所示质量标准
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio class="checkbox-top2" label="2" key="2">
                    （2）双方约定的质量标准
                    <div></div>
                    <el-input class="mar5-t" style="width: 500px" type="textarea" placeholder="请输入内容"
                      v-model="attrVal.contract60" :maxlength="200" show-word-limit></el-input>
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio label="3" key="3">
                    （3）按农信商城商品详情页列明的商品标准执行。
                  </el-radio>
                </el-radio-group>

                <div>赔付与拒收的标准</div>
                <el-input style="width: 500px" type="textarea" placeholder="请输入内容" v-model="attrVal.contract23"
                  :maxlength="200" show-word-limit></el-input>
              </div>
            </li>
            <li class="clearfix flex mar20_b">
               <div class="nowrap">交 付：</div>
              <div>
                甲乙双方一致选择以下选项约定进行交付：
                <div></div>
                <el-radio-group v-model="attrVal.contract41">
                  <el-radio label="1" key="1">
                    （1）本合同签订后<el-input-number controls-position="right" size="small" :precision="2" :step="1"
                      :min="0.01" :max="300" class="w80 mar5 dpad5" v-model="attrVal.contractData1">
                    </el-input-number>日内，甲方向乙方或乙方下游买方指定的地点和收货人发货（向乙方指定收货人送达货物即视为向乙方送达货物）。
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio label="2" key="2">
                    （2）甲方收到乙方<el-input-number controls-position="right" size="small"
                      :precision="2" :step="1" :min="0.01" :max="100" class="w80 mar5 dpad5"
                      v-model="attrVal.contractData2"></el-input-number>%货款后<el-input-number controls-position="right"
                      size="small" :precision="2" :step="1" :min="0.01" :max="300" class="w80 mar5 dpad5"
                      v-model="attrVal.contractData3"></el-input-number>日内，向乙方指定的地点和收货人发货。
                  </el-radio>
                  <div class="mar10-t"></div>
                  <template v-if="templateMethodSel == 'CG-YR'|| templateMethodSel == 'CG-KLMY'">
                    <el-radio label="3" key="3">
                      （3）其他交付方式：
                    </el-radio>
                    <div class="mar10-t"></div>
                    <el-input style="width: 552px" type="textarea" placeholder="请输入内容" v-model="attrVal.contract53"
                      :maxlength="200" show-word-limit></el-input>
                  </template>
                  <template v-else>
                    <el-radio label="3" key="3">
                      （3）约定的交货期间：从<el-input class="selt w200" v-model="attrVal.contract66"
                      maxlength="11" ></el-input> 到<el-input class="selt w200" v-model="attrVal.contract67"
                      maxlength="11" ></el-input>，这此期间，由甲方提前<el-input-number controls-position="right" size="small" :step="1"
                    :min="0" :max="300" class="w80 mar5 dpad5" v-model="attrVal.contract68">
                  </el-input-number>天通知乙方提货或分期提货。
                    </el-radio>
                    <div class="mar10-t"></div>
                    <el-radio label="4" key="4">
                      （4）其他交付方式：
                    </el-radio>
                    <div class="mar10-t"></div>
                    <el-input style="width: 552px" type="textarea" placeholder="请输入内容" v-model="attrVal.contract53"
                      :maxlength="200" show-word-limit></el-input>
                  </template>
                  
                </el-radio-group>

              </div>
            </li>
              <li class="clearfix flex mar20_b">
                <div></div>
                <div>
                  交货方式：双方一致同意按照以下方式进行交货。
                  <div></div>
                  <el-radio-group v-model="attrVal.contract69">
                    <el-radio label="1" key="1">
                      （1）甲方直接送货或委托第三方送货，该商品自送到乙方指定地点并由指定接收人或下单人签收的（指在电子签署单上签收或在订单上确认收货），</br>视为乙方收货完成，甲方委托第三方快递公司配送的，自配送到乙方指定地点的，视为乙方收货完成，其相关的运费由甲方承担。
                    </el-radio>
                    <div class="mar10-t"></div>
                    <el-radio label="2" key="2">
                      （2）乙方指定人员上门提货，自乙方指定人员或下单人员签署电子签收单或通过农信商城确认收货的，视为乙方收货完成，其相关的运费由乙方承担。
                    </el-radio>
                    <div class="mar10-t"></div>
                    <el-radio label="3" key="3">
                      （3）甲方将乙方订购货物暂存于甲方或第三方仓库，自乙方通过农信商城确认由甲方发出的提货单后，该商品的所有权即归乙方所有，乙方享有完全的
                    </br>处置该商品的权利，甲方不得自行处置或将该商品转卖给其他第三方。该方式下，甲方按照乙方提货要求，应在约定时间内将货物转交给乙方指定的
                  </br>收货人，当收货人或下单人签署电子签收单或通过农信商城确认收货的，视为乙方收货完成，其相关的运费由乙方
                      承担。
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="clearfix flex mar20_b">
                <div></div>
                <div>
                  双方约定按照以下项确定交货地址
                  <div></div>
                  <el-radio-group v-model="attrVal.contract70">
                    <el-radio label="1" key="1">
                      （1）以订单上标识的指定交货地址为准
                    </el-radio>
                    <div class="mar10-t"></div>
                    <el-radio label="2" key="2">
                      （2）由甲方指定提货地点，提前<el-input-number controls-position="right" size="small" :step="1"
                        :min="0" :max="300" class="w80 mar5 dpad5" v-model="attrVal.contract71">
                      </el-input-number>天通知乙方（通过订单信息）
                    </el-radio>
                  </el-radio-group>
                </div>
            </li>

            <li class="clearfix flex mar20_b">

              <div class="nowrap">货款结算：</div>
              <div>
                结算与付款方式：根据农信平台支付规则进行线上支付结算，甲乙双方一致选择以下选项结算方式
                <div></div>
                <el-radio-group v-model="attrVal.contract40">
                  <el-radio label="1" key="1">
                    （1）先款后货，乙方在本合同签订<el-input-number controls-position="right" size="small" :precision="2"
                      :step="1" :min="0.01" :max="300" class="w80 mar5 dpad5"
                      v-model="attrVal.contractData4"></el-input-number>天内，通过农信商城平台先行全额预付或结算给甲方款项，乙方可一次性或分批提货，多余部分由甲方通过平台退还。
                  </el-radio>
                  <div></div>
                  <el-radio label="2" key="2">
                    （2）货到付款，乙方或指定收货人对该订单或批次货物验收合格并确认收货后（签署电子签收单）<el-input-number controls-position="right" size="small"
                      :precision="2" :step="1" :min="0.01" :max="300" class="w80 mar5 dpad5"
                      v-model="attrVal.contractData15"></el-input-number>日内，乙方将全部货款通过平台结算给甲方。
                  </el-radio>
                  <div></div>
                  <el-radio label="3" key="3">
                    （3）分次付款，本合同签署后<el-input-number controls-position="right" size="small" :precision="2" :step="1"
                      :min="0.01" :max="300" class="w80 mar5 dpad5"
                      v-model="attrVal.contractData5"></el-input-number>日内乙方付<el-input-number controls-position="right"
                      size="small" :precision="2" :step="1" :min="0.01" :max="100" class="w80 mar5 dpad5"
                      v-model="attrVal.contractData6"></el-input-number>%款项，产品、货物装车/装船后当日内乙方付<el-input-number
                      controls-position="right" size="small" :precision="2" :step="1" :min="0.01" :max="100"
                      class="w80 mar5 dpad5"
                      v-model="attrVal.contractData7"></el-input-number>%款项，</br>乙方指定收货人确认收货后<el-input-number
                      controls-position="right" size="small" :precision="2" :step="1" :min="0.01" :max="300"
                      class="w80 mar5 dpad5" v-model="attrVal.contractData8"></el-input-number>日内乙方付<el-input-number
                      controls-position="right" size="small" :precision="2" :step="1" :min="0.01" :max="100"
                      class="w80 mar5 dpad5" v-model="attrVal.contractData9"></el-input-number>%款项
                  </el-radio>
                  <div></div>
                  <el-radio class="checkbox-top" label="4" key="4">
                    （4）先验后款，乙方指定收货人收到货物后（签署电子签收单）并验收合格后的<el-input-number controls-position="right" size="small" :step="1"
                      :min="0" :max="300" class="w80 mar5 dpad5"
                      v-model="attrVal.contract72"></el-input-number>日内通过平台将全款结算给甲方。
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio class="checkbox-top" label="5" key="5">
                    （5）限定天数结算。乙方应在甲方发货后<el-input-number controls-position="right" size="small" :precision="2" :step="1"
                      :min="0.01" :max="300" class="w80 mar5 dpad5"
                      v-model="attrVal.contractData14"></el-input-number>日内将全部货款通过平台结算给甲方。
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio class="checkbox-top" label="6" key="6">
                    （6）按发货进度付款：合同签订后<el-input-number controls-position="right" size="small" :step="1"
                      :min="0" :max="300" class="w80 mar5 dpad5"
                      v-model="attrVal.contract73"></el-input-number>日内支付合同总额的<el-input-number
                      controls-position="right" size="small" :precision="2" :step="1" :min="0.01" :max="100"
                      class="w80 mar5 dpad5" v-model="attrVal.contract74"></el-input-number>%作为定金即
                      <el-input-number controls-position="right" size="small" :precision="2" :step="1"
                      :min="0.01" class="w200 mar5 dpad5"
                      v-model="attrVal.contract75"></el-input-number>元，剩余货款在每次提货前支付，</br>已支付定金在需方最后一次提货时转为货款结算。
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio class="checkbox-top" label="7" key="7">
                    （7）固定时间节点结算，乙方于每月<el-input-number controls-position="right" size="small" :precision="2" :step="1"
                      :min="0.01" :max="300" class="w80 mar5 dpad5"
                      v-model="attrVal.contractData11"></el-input-number>日将指定收货人验收合格并确认收货但未结算的货款通过平台结算给甲方。
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio label="8" key="8">
                    （8）其他结算方式
                  </el-radio>
                </el-radio-group>
                <div class="mar10-t"></div>
                <el-input style="width: 528px" type="textarea" placeholder="请输入内容" v-model="attrVal.contract54"
                  :maxlength="200" show-word-limit></el-input>
              </div>
            </li>
            <li class="clearfix flex mar20_b">
              违约责任：
              <div>
                特别约定
                <div></div>
                <el-input style="width: 528px" type="textarea" placeholder="请输入内容" v-model="attrVal.contract25"
                  :maxlength="200" show-word-limit></el-input>
              </div>
            </li>
            <li class="clearfix flex pad10-l mar20_b">
              补充条款：
              <div>
                <el-input style="width: 528px" type="textarea" placeholder="请输入内容" v-model="attrVal.contract26"
                  :maxlength="200" show-word-limit></el-input>
              </div>
            </li>
          </ul>
        </template>

        <!--代销合同-->
        <template v-else-if="templateMethodSel == 'XS-PTKH'">
          <ul>
            <li class="clearfix mar20_b pad10-l">产品（货物）型号、数量、金额</li>
            <li class="clearfix mar20_b">
              短溢量：±
              <el-input-number controls-position="right" size="small" :precision="2" :step="1" :min="0.01" :max="100"
                class="w80 mar5 dpad5" v-model="attrVal.contract22"></el-input-number>%，此范围内根据实际交货数量及约定销售单价计算最终合同价款。
            </li>
            <li class="clearfix flex mar20_b">
              <div class="relative" style="top: -14px;">产品质量标准：</div>
              <div>
                <el-radio-group v-model="attrVal.contract58">
                  <el-radio label="1" key="1">
                    （1）按照标签所示质量标准
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio class="checkbox-top2" label="2" key="2">
                    （2）双方约定的质量标准
                    <div></div>
                    <el-input class="mar5-t" style="width: 500px" type="textarea" placeholder="请输入内容"
                      v-model="attrVal.contract60" :maxlength="200" show-word-limit></el-input>
                  </el-radio>
                </el-radio-group>
                <div>赔付与拒收的标准</div>
                <el-input style="width: 500px" type="textarea" placeholder="请输入内容" v-model="attrVal.contract23"
                  :maxlength="200" show-word-limit></el-input>
              </div>
            </li>
            <li class="clearfix flex mar20_b">
              交 付：
              <div>
                由甲方上游供应商直接向乙方交付，甲乙双方一致选择以下选项约定进行交付
                <!-- <el-input
                  style="width: 200px"
                  placeholder="请输入内容"
                  v-model="attrVal.contract50"
                ></el-input> -->
                <div></div>
                <el-radio-group v-model="attrVal.contract41">
                  <el-radio label="1" key="1">
                    （1）本合同签订后<el-input-number controls-position="right" size="small" :precision="2" :step="1"
                      :min="0.01" :max="300" class="w80 mar5 dpad5"
                      v-model="attrVal.contractData1"></el-input-number>日内，甲方上游供应商向乙方指定的地点和收货人发货（向乙方指定收货人送达货物即视为乙方签收货物）
                  </el-radio>
                  <div></div>
                  <el-radio label="2" key="2">
                    （2）甲方收到乙方<el-input-number controls-position="right" size="small" :precision="2" :step="1"
                      :min="0.01" :max="100" class="w80 mar5 dpad5" v-model="attrVal.contractData2">
                    </el-input-number>%货款后<el-input-number controls-position="right" size="small" :precision="2"
                      :step="1" :min="0.01" :max="300" class="w80 mar5 dpad5"
                      v-model="attrVal.contractData3"></el-input-number>
                    日内，甲方上游供应商向乙方指定的地点和收货人发货
                  </el-radio>
                  <div></div>
                  <el-radio label="3" key="3">
                    （3）其他交付方式：
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-input style="width: 552px" type="textarea" placeholder="请输入内容" v-model="attrVal.contract53"
                    :maxlength="200" show-word-limit></el-input>
                </el-radio-group>
                <!-- <div class="mar20-t">
                  交货方式及运费承担：采用选择以下选项方式交货<font class="red">（默认获取订单配送方式）</font>
                </div>
                <el-radio-group v-model="attrVal.contract18">
                  <el-radio label="1" key="1">
                    （1）送货上门，运费由甲方上游供应商承担
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio label="2" key="2">
                    （2）乙方自提，运费由乙方承担
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio label="3" key="3">
                    （3）货联配送，运费由甲方上游供应商承担
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio label="4" key="4">
                    （4）其他第三方配送，运费由甲方上游供应商承担
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio label="5" key="5">
                    （5）其他方式
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-input style="width: 552px" type="textarea" placeholder="请输入内容" v-model="attrVal.contract61"
                    :maxlength="200" show-word-limit></el-input>
                </el-radio-group> -->
              </div>
            </li>
            <!-- <li class="clearfix mar20_b">
              产品验收：
              产品到达交货地点后，需要进行质量验收的，需由乙方自到货<el-input-number controls-position="right" size="small" :precision="2"
                :step="1" :min="0.01" :max="300" class="w80 mar5 dpad5"
                v-model="attrVal.contract33"></el-input-number>日内按约定的包装和质量标准进行验收。非因质量问题未及时收货导致的仓储费用由乙方承担
            </li> -->
            <li class="clearfix flex mar20_b">
              <div class="nowrap">货款结算：</div>
              <div>
                结算与付款方式：根据农信平台支付规则进行线上支付结算，甲乙双方一致选择以下选项结算方式
                <div></div>
                <el-radio-group v-model="attrVal.contract40">
                  <el-radio label="1" key="1">
                    （1）先款后货，本合同签署后<el-input-number controls-position="right" size="small" :precision="2" :step="1"
                      :min="0.01" :max="300" class="w80 mar5 dpad5"
                      v-model="attrVal.contractData4"></el-input-number>日内，乙方通过平台将全款结算给甲方，甲方根据与其上游供应商的约定进行结算支付
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio label="2" key="2">
                    （2）货到付款，乙方及其指定收货人收到订单货物的当日将全部货款通过平台结算给甲方，甲方根据与其上游供应商的约定进行结算支付
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio class="checkbox-top" label="3" key="3">
                    （3）分次付款，本合同签署后<el-input-number controls-position="right" size="small" :precision="2" :step="1"
                      :min="0.01" :max="300" class="w80 mar5 dpad5"
                      v-model="attrVal.contractData5"></el-input-number>日内乙方付<el-input-number controls-position="right"
                      size="small" :precision="2" :step="1" :min="0.01" :max="100" class="w80 mar5 dpad5"
                      v-model="attrVal.contractData6"></el-input-number>%款项，产品、货物装车/装船后当日内乙方付<el-input-number
                      controls-position="right" size="small" :precision="2" :step="1" :min="0.01" :max="100"
                      class="w80 mar5 dpad5" v-model="attrVal.contractData7"></el-input-number>
                    <br />%款项，乙方及其指定收货人确认收货后<el-input-number controls-position="right" size="small" :precision="2"
                      :step="1" :min="0.01" :max="300" class="w80 mar5 dpad5"
                      v-model="attrVal.contractData8"></el-input-number>日内向甲方付<el-input-number controls-position="right"
                      size="small" :precision="2" :step="1" :min="0.01" :max="100" class="w80 mar5 dpad5"
                      v-model="attrVal.contractData9"></el-input-number>%款项，甲方将收到的款项按照与其上游供应商的约定结算给上游供应商
                  </el-radio>
                  <div class="mar10-t"></div>
                  <el-radio label="4" key="4">
                    （4）其他结算方式
                  </el-radio>
                </el-radio-group>
                <div class="mar10-t"></div>
                <el-input style="width: 528px" type="textarea" placeholder="请输入内容" v-model="attrVal.contract54"
                  :maxlength="200" show-word-limit></el-input>
              </div>
            </li>
            <li class="clearfix flex mar20_b">
              违约责任：
              <div>
                甲乙双方对于违约责任的特别约定
                <div></div>
                <el-input style="width: 528px" type="textarea" placeholder="请输入内容" v-model="attrVal.contract25"
                  :maxlength="200" show-word-limit></el-input>
              </div>
            </li>
            <li class="clearfix flex pad10-l mar20_b">
              补充条款：
              <div>
                <el-input style="width: 528px" type="textarea" placeholder="请输入内容" v-model="attrVal.contract26"
                  :maxlength="200" show-word-limit></el-input>
              </div>
            </li>
          </ul>
        </template>

        <!--设备模板-->
        <template v-else-if="templateMethodSel == 'SHEBEI_CONTRACT'">
          <ul>
            <li class="clearfix mar20_b">
              <label class="w130 pad30_r pull-left text-right"><em class="red">*</em>合同模板类型</label>
              <div class="pull-left ">
                <el-select v-model="templateMethodSel" placeholder="请选择合同模板类型" :disabled="attrId != 0">
                  <el-option v-for="option in contractTemplateTypeList" :key="option.val" :label="option.text"
                    :value="option.val"> </el-option>
                </el-select>
              </div>
            </li>
            <li class="clearfix mar20_b">
              <label class="f18 fb pad20_r pull-left text-right">一、交货时间、方式和地点</label>
            </li>
            <li class="clearfix mar20_b">
              <div class="pull-left pad15_l pad30_r">
                <div class="clear paymethod">
                  <div class="clearfix">
                    <em class="red">*</em>交货时间：乙方或乙方上游供应商应当于甲方在农信商城下单后
                    <el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1" :max="15"
                      class="w80 mar5 dpad5" v-model="paymentMethodSheBeiValue[1]"
                      @change="inputNumberChange($event)"></el-input-number>
                    日内发货。但双方另有约定的，从约定。
                  </div>
                  <div class="box10"></div>
                  <div class="clearfix">
                    <em class="red">*</em>
                    确认收货：甲方收到货物后应在
                    <el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1" :max="100"
                      class="w80 mar5 dpad5" v-model="paymentMethodSheBeiValue[2]"
                      @change="inputNumberChange($event)"></el-input-number>
                    日内在农信商城平台确认收货。超过
                    <el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1" :max="15"
                      class="w80 mar5 dpad5" v-model="paymentMethodSheBeiValue[3]"
                      @change="inputNumberChange($event)"></el-input-number>
                    日乙方系统将自动确认收货。确认收货后，仅有质量问题的产品支持换货或退货。
                  </div>
                </div>
              </div>
            </li>
            <li class="clearfix mar20_b">
              <label class="f18 fb pad20_r pull-left text-right">二、安装调试和培训</label>
            </li>
            <li class="clearfix mar20_b">
              <label class="w130 pad30_r pull-left text-right"><em class="red">*</em>安装\培训方式</label>
              <div class="pull-left ">
                <el-select v-model="installTransportModeSel" placeholder="请选择安装和培训方式" style="width: 800px">
                  <el-option v-for="option in installTransportModeList" :key="option.val" :label="option.text"
                    :value="option.val"> </el-option>
                </el-select>
              </div>
            </li>
            <li class="clearfix mar20_b">
              <label class="f18 fb pad20_r pull-left text-right">三、设备验收</label>
            </li>
            <li class="clearfix mar20_b">
              <div class="pull-left pad15_l pad30_r">
                <div class="clear paymethod">
                  <div class="clearfix">
                    <em class="red">*</em>
                    甲方收到本合同所包含的全部货物后，按照乙方或其上游供应商提供的装箱清单对货物进行验收，如产品的规格、型号与合同约定不符、外形损坏或者数量缺失的，甲方应在收到货物
                    <el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1" :max="15"
                      class="w80 mar5 dpad5" v-model="motorTransportAcceptanceDays"
                      @change="inputNumberChange($event)"></el-input-number>
                    日内向乙方提出书面异议，逾期未提出异议视为验收合格。</br>
                    乙方或其上游供应商在收到甲方通知且核实后
                    <el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1" :max="15"
                      class="w80 mar5 dpad5" v-model="replacementDays"
                      @change="inputNumberChange($event)"></el-input-number>
                    日内负责换货或者补货。
                  </div>
                  <div class="box10"></div>
                  <div class="clearfix">
                    <em class="red">*</em>
                    甲方应于到货后及时安排己方或乙方所派技术人员对设备进行安装、调试，如发现产品存在质量问题的，甲方应于
                    <el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1" :max="15"
                      class="w80 mar5 dpad5" v-model="secondPartyInspectionDays"
                      @change="inputNumberChange($event)"></el-input-number>
                    日内提出书面异议及依据，由乙方或其上游供应商核实后负责更换合格产品，无法更换的予以退货；甲方逾期提出异议，视为产品质量验收合格。</br>
                    甲方收到货后
                    <el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1" :max="15"
                      class="w80 mar5 dpad5" v-model="motorTransportInspectionDays"
                      @change="inputNumberChange($event)"></el-input-number>
                    日未进行安装、调试的，视为产品质量合格。
                  </div>
                </div>
              </div>
            </li>
            <li class="clearfix mar20_b">
              <label class="f18 fb pad20_r pull-left text-right">四、质量保修</label>
            </li>
            <li class="clearfix mar20_b">
              <div class="pull-left pad15_l pad30_r">
                <div class="clear paymethod">
                  <div class="clearfix">
                    <em class="red">*</em>
                    设备保修期为
                    <el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1" :max="10"
                      class="w80 mar5 dpad5" v-model="specialQualityAgreement"
                      @change="inputNumberChange($event)"></el-input-number>
                    年，自乙方交付之日起算。
                  </div>
                </div>
              </div>
            </li>
            <li class="clearfix mar20_b">
              <label class="f18 fb pad20_r pull-left text-right">五、违约责任</label>
            </li>
            <li class="clearfix mar20_b">
              <div class="pull-left pad15_l pad30_r">
                <div class="clear paymethod">
                  <div class="clearfix">
                    <em class="red">*</em>
                    乙方逾期交付设备的，每逾期一日，按未交付设备货款的
                    <el-input-number controls-position="right" size="small" :precision="2" :step="1" :min="0.01"
                      :max="100" class="w80 mar5 dpad5" v-model="firstPartyFalsifyRate"
                      @change="inputNumberChange($event)"></el-input-number>
                    ‰计算违约金，违约金最高不超过合同总价的10%。</br>
                    逾期
                    <el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1" :max="15"
                      class="w80 mar5 dpad5" v-model="firstPartyFalsifyDays"
                      @change="inputNumberChange($event)"></el-input-number>
                    天仍未交货的，甲方有权终止合同，乙方应返还甲方预付款并支付逾期违约金。
                  </div>
                </div>
              </div>
            </li>
            <li class="clearfix mar20_b">
              <label class="f18 fb pad20_r pull-left text-right">六、补充条款</label>
            </li>
            <li class="clearfix mar20_b">
              <div class="pull-left pad15_l pad30_r">
                <div class="clear paymethod">
                  <div class="clearfix">
                    <label class="pad10_r block normal">电子合同补充条款</label>
                    <el-input style="width: 500px" type="textarea" placeholder="请输入内容" v-model="contractSupplement"
                      :maxlength="200" show-word-limit></el-input>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </template>

        <!--vip模板-->
        <template v-else-if="templateMethodSel == 'VIP_CONTRACT'">
          <ul>
            <li class="clearfix mar20_b">
              <label class="f18 fb pad20_r pull-left text-right">一、关于收费</label>
            </li>
            <li class="clearfix mar20_b">
              <label class="w130 pad30_r pull-left text-right"><em class="red">*</em>支付方式</label>
              <div class="pull-left ">
                甲方应根据以下
                <el-select v-model="paymentMethodVipValue" placeholder="请选择支付方式">
                  <el-option v-for="option in paymentMethodVipList" :key="option.val" :label="option.name"
                    :value="option.val"> </el-option>
                </el-select>
                方式支付VIP商城会员服务费
              </div>
            </li>
            <li class="clearfix mar20_b">
              <label class="f18 fb pad20_r pull-left text-right">二、补充条款</label>
            </li>
            <li class="clearfix mar20_b">
              <div class="pull-left pad15_l pad30_r">
                <div class="clear paymethod">
                  <div class="clearfix">
                    <label class="pad10_r block normal">电子合同补充条款</label>
                    <el-input style="width: 500px" type="textarea" placeholder="请输入内容" v-model="contractSupplement"
                      :maxlength="200" show-word-limit></el-input>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </template>

        <template v-else>
          <ul>
            <li class="clearfix mar20_b" v-if="templateMethodSel != 'XS-PTKH'">
              <label class="w130 pad30_r pull-left text-right"><em class="red">*</em>合同模板类型</label>
              <div class="pull-left">
                <el-select v-model="templateMethodSel" placeholder="请选择合同模板类型"
                  :disabled="attrId != 0 && transferAttrId">
                  <el-option v-for="option in templateMethodList" :key="option.val" :label="option.text"
                    :value="option.val"> </el-option>
                </el-select>
              </div>
            </li>
            <!--供应商→普通-->
            <template v-if="templateMethodSel == 'PT-PTKH'">
              <li class="clearfix mar20_b">
                <label class="w130 pad30_r pull-left text-right"><em class="red">*</em>支付方式</label>
                <div class="pull-left ">
                  <el-select v-model="paymentMethodValue[0]" placeholder="请选择支付方式" @change="paymentMethodSel">
                    <el-option v-for="option in paymentMethodList" :key="option.val" :label="option.text.split(',')[0]"
                      :value="option.val"> </el-option>
                  </el-select>
                </div>
              </li>
              <li class="clearfix mar20_b">
                <div class="pull-left pad15_l pad30_r" style="padding-left: 90px;">
                  <div class="clearfix normal pad35_l" v-if="paymentMethodValue[0] == '多次支付'">
                    本合同签署后
                    <el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1"
                      class="w80 mar5 dpad5" v-model="paymentMethodValue[1]"
                      @change="inputNumberChange($event)"></el-input-number>日内付
                    <el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1" :max="100"
                      class="w80 mar5 dpad5" v-model="paymentMethodValue[2]"
                      @change="inputNumberChange($event)"></el-input-number>%款项，</br>
                    产品、货物装车/装船后 当日内付<el-input-number controls-position="right" size="small" :precision="0" :step="1"
                      :min="1" :max="100" class="w80 mar5 dpad5" v-model="paymentMethodValue[3]"
                      @change="inputNumberChange($event)"></el-input-number>%款项，
                    确认收货后<el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1"
                      class="w80 mar5 dpad5" v-model="paymentMethodValue[4]"
                      @change="inputNumberChange($event)"></el-input-number>日内付
                    <el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1" :max="100"
                      class="w80 mar5 dpad5" v-model="paymentMethodValue[5]"
                      @change="inputNumberChange($event)"></el-input-number>%款项，</br>
                    支付首笔款后<el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1"
                      class="w80 mar5 dpad5" v-model="paymentMethodValue[6]"
                      @change="inputNumberChange($event)"></el-input-number>日内发货。
                  </div>
                  <div class="clearfix normal pad35_l" v-if="paymentMethodValue[0] == '先款后货'">
                    本合同签署后<el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1"
                      class="w80 mar5 dpad5" v-model="paymentMethodValue[1]"
                      @change="inputNumberChange($event)"></el-input-number>
                    日内付全款，付款后<el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1"
                      class="w80 mar5 dpad5" v-model="paymentMethodValue[2]"
                      @change="inputNumberChange($event)"></el-input-number>日内发货。
                  </div>
                  <div class="clearfix normal pad35_l" v-if="paymentMethodValue[0] == '先货后款'">
                    本合同签署后<el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1"
                      class="w80 mar5 dpad5" v-model="paymentMethodValue[1]"
                      @change="inputNumberChange($event)"></el-input-number>
                    日内发货，验收合格后<el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1"
                      class="w80 mar5 dpad5" v-model="paymentMethodValue[2]"
                      @change="inputNumberChange($event)"></el-input-number>日内付全款。
                  </div>
                  <div class="clearfix pad30_l">
                    <label class="pad10_r block normal">客户对货品质量标准的特别约定</label>
                    <el-input style="width: 500px" type="textarea" placeholder="请输入内容" v-model="specialQualityAgreement"
                      :maxlength="200" show-word-limit></el-input>
                  </div>
                </div>
              </li>
              <li class="clearfix mar20_b">
                <label class="w130 pad30_r pull-left text-right"><em class="red">*</em>运输方式</label>
                <div class="pull-left ">
                  <el-select v-model="transportModeSel" placeholder="请选择运输方式">
                    <el-option v-for="option in transportModeList" :key="option.val" :label="option.text"
                      :value="option.val"> </el-option>
                  </el-select>
                </div>
              </li>
              <li class="clearfix mar20_b">
                <label class="w130 pad30_r pull-left text-right"><em class="red">*</em>运费承担</label>
                <div class="pull-left ">
                  <el-select v-model="freightBearSel" placeholder="请选择运费承担">
                    <el-option v-for="option in freightBearList" :key="option.val" :label="option.text"
                      :value="option.val"> </el-option>
                  </el-select>
                </div>
              </li>
              <li class="clearfix mar20_b">
                <label class="w130 pad30_r pull-left text-right"><em class="red">*</em>诉讼所在地</label>
                <div class="pull-left ">
                  <el-select v-model="lawsuitLocationSel" placeholder="请选择诉讼所在地">
                    <el-option v-for="option in lawsuitLocationList" :key="option.val" :label="option.text"
                      :value="option.val"> </el-option>
                  </el-select>
                </div>
              </li>
              <li class="clearfix mar20_b">
                <div class="pull-left pad15_l pad30_r">
                  <div class="clearfix normal pad35_l">
                    <em class="red">*</em>短溢量(仅适用于大宗原料)：±
                    <el-input-number controls-position="right" size="small" :precision="2" :step="1" :min="0.01"
                      :max="100" class="w80 mar5 dpad5" v-model="shortSpillover"
                      @change="inputNumberChange($event)"></el-input-number>%，在此范围内根据实际交货数量及本合同约定销售单价计算最终合同价款。
                  </div>
                  <div class="clear pad35_l paymethod">
                    <div class="clearfix">
                      <em class="red">*</em>甲方逾期交付产品的，每逾期一天，应按照合同总价款的
                      <el-input-number controls-position="right" size="small" :precision="2" :step="1" :min="0.01"
                        :max="100" class="w80 mar5 dpad5" v-model="firstPartyFalsifyRate"
                        @change="inputNumberChange($event)"></el-input-number>%向乙方支付违约金，逾期超过5天的，则乙方有权解除合同，且甲方应当全额退还乙方已经支付的合同价款。
                    </div>
                    <div class="box10"></div>
                    <div class="clearfix">
                      <em class="red">*</em>乙方逾期付款的，每逾期一天，应按照合同未付款的
                      <el-input-number controls-position="right" size="small" :precision="2" :step="1" :min="0.01"
                        :max="100" class="w80 mar5 dpad5" v-model="secondPartyFalsifyRate"
                        @change="inputNumberChange($event)"></el-input-number>%向甲方支付违约金。
                    </div>
                    <div class="box10"></div>
                    <div class="clearfix">
                      <em class="red">*</em>乙方应在当批次货物验收合格后
                      <el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1"
                        :max="15" class="w80 mar5 dpad5" v-model="secondPartyInspectionDays"
                        @change="inputNumberChange($event)"></el-input-number>日内在平台上确认收货，逾期未确认收货的，平台在甲方提供验收合格相关证明后在确认
                    </div>
                    <div class="clearfix">
                      收货期限届满之日起
                      <el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1"
                        :max="15" class="w80 mar5 dpad5" v-model="platformAdvanceDays"
                        @change="inputNumberChange($event)"></el-input-number>日内自动将该批次对应货款划给甲方。
                    </div>
                    <div class="box10"></div>
                    <div class="clearfix">
                      <em class="red">*</em>产品到达收货地点后，采用火车或轮船运输的乙方应在存放方通知或要求的可免费存放并提货时间内，
                      采用汽车运输的乙方应在到货后
                      <el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1"
                        :max="15" class="w80 mar5 dpad5" v-model="motorTransportInspectionDays"
                        @change="inputNumberChange($event)"></el-input-number>日内，由乙方按双方按约定的包装和质量标准进行验收。
                    </div>
                    <div class="box10"></div>
                    <div class="clearfix">
                      <em class="red">*</em>乙方有异议的应在验收后
                      <el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1"
                        :max="15" class="w80 mar5 dpad5" v-model="motorTransportAcceptanceDays"
                        @change="inputNumberChange($event)"></el-input-number>日内以书面方式（含邮件）反馈给甲方，否则视为所交付产品符合约定并完成交货。
                    </div>
                    <div class="box10"></div>
                    <div class="clearfix">
                      <em
                        class="red">*</em>甲方应在乙方支付最后一笔款项前，先行向乙方开具全额的合法增值税发票（应税商品应开具增值税专用发票），甲方未按约定及时开具全额发票的，乙方有权延迟支付本协议第5.1条约定的尾款且不构成违约，且每逾期一日甲方应按未开票金额的
                      <el-input-number controls-position="right" size="small" :precision="2" :step="1" :min="0.01"
                        :max="100" class="w80 mar5 dpad5" v-model="notInvoicedAmountRate"
                        @change="inputNumberChange($event)"></el-input-number>%向乙方支付违约金。
                    </div>
                    <div>
                      <span style="color: #7F7F7F;background-color: #F4F4F4">此条款仅与平台方进行交易时有效，并进行展示</span>
                    </div>
                  </div>
                </div>
              </li>
            </template>

            <!--农信→平台客户-->
            <template v-if="templateMethodSel == 'XS-PTKH'">
              <li class="clearfix mar20_b">
                <label class="w130 pad30_r pull-left text-right"><em class="red">*</em>支付方式</label>
                <div class="pull-left ">
                  <el-select v-model="paymentMethodPTValue[0]" placeholder="请选择支付方式" v-on:change="paymentMethodPTSel">
                    <el-option v-for="option in paymentMethodPTList" :key="option.val" :label="option.name"
                      :value="option.val"> </el-option>
                  </el-select>
                </div>
              </li>
              <li class="clearfix mar20_b">
                <div class="pull-left pad15_l pad30_r" style="padding-left: 90px;">
                  <div class="clearfix normal pad35_l" v-if="paymentMethodPTValue[0] == '4'">
                    本合同签署后<el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1"
                      class="border w80 mar5 dpad5" v-model="paymentMethodPTValue[1]"
                      @change="inputNumberChange($event)"></el-input-number>日内乙方付
                    <el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1" :max="100"
                      class="border w80 mar5 dpad5" v-model="paymentMethodPTValue[2]"
                      @change="inputNumberChange($event)"></el-input-number>%款项，</br>
                    产品、货物装车/装船后当日内乙方付<el-input-number controls-position="right" size="small" :precision="0" :step="1"
                      :min="0" :max="100" class="border w80 mar5 dpad5" v-model="paymentMethodPTValue[3]"
                      @change="inputNumberChange($event)"></el-input-number>%款项，</br>
                    乙方及下游客户确认收货后<el-input-number controls-position="right" size="small" :precision="0" :step="1"
                      :min="1" class="border w80 mar5 dpad5" v-model="paymentMethodPTValue[4]"
                      @change="inputNumberChange($event)"></el-input-number>日内付
                    <el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="0" :max="100"
                      class="border w80 mar5 dpad5" v-model="paymentMethodPTValue[5]"
                      @change="inputNumberChange($event)"></el-input-number>%款项，</br>
                    甲方收到乙方<el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="0"
                      :max="100" class="border w80 mar5 dpad5" v-model="paymentMethodPTValue[7]"
                      @change="inputNumberChange($event)"></el-input-number>%货款后
                    <el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1"
                      class="border w80 mar5 dpad5" v-model="paymentMethodPTValue[6]"
                      @change="inputNumberChange($event)"></el-input-number>日内，甲方上游供应商向乙方指定的地点和收货人发货。
                  </div>
                  <div class="clearfix normal pad35_l" v-if="paymentMethodPTValue[0] == '1'">
                    本合同签署后<el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1"
                      class="border w80 mar5 dpad5" v-model="paymentMethodPTValue[2]"
                      @change="inputNumberChange($event)"></el-input-number>日内，甲方上游供应商向乙方指定的地点和收货人发货。</br>
                    本合同签署后<el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1"
                      class="border w80 mar5 dpad5" v-model="paymentMethodPTValue[1]"
                      @change="inputNumberChange($event)"></el-input-number>日内乙方通过平台将全款结算给甲方。
                  </div>
                  <div class="clearfix normal pad35_l" v-if="paymentMethodPTValue[0] == '2'">
                    乙方对该订单或批次货物验收合格并确认收货后<el-input-number controls-position="right" size="small" :precision="0"
                      :step="1" :min="1" class="border w80 mar5 dpad5" v-model="paymentMethodPTValue[1]"
                      @change="inputNumberChange($event)"></el-input-number>日内，乙方将全部货款通过平台结算给甲方</br>
                    本合同签订后<el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1"
                      class="border w80 mar5 dpad5" v-model="paymentMethodPTValue[2]"
                      @change="inputNumberChange($event)"></el-input-number>日内，甲方上游供应商向乙方指定的地点和收货人发货。
                  </div>
                  <div class="clearfix pad30_l">
                    <label class="pad10_r block normal">客户对货品质量标准的特别约定</label>
                    <el-input style="width: 500px" type="textarea" placeholder="请输入内容" v-model="specialQualityAgreement"
                      :maxlength="200" show-word-limit></el-input>
                  </div>
                </div>
              </li>
              <li class="clearfix mar20_b">
                <label class="w130 pad30_r pull-left text-right"><em class="red">*</em>运费承担</label>
                <div class="pull-left ">
                  <el-select v-model="freightBearPTSel" placeholder="请选择运费承担">
                    <el-option v-for="option in freightBearPTList" :key="option.val" :label="option.text"
                      :value="option.val"> </el-option>
                  </el-select>
                </div>
              </li>
              <li class="clearfix mar20_b">
                <label class="w130 pad30_r pull-left text-right"><em class="red">*</em>诉讼所在地</label>
                <div class="pull-left ">
                  <el-select v-model="lawsuitLocationSel" placeholder="请选择诉讼所在地">
                    <el-option v-for="option in lawsuitLocationList" :key="option.val" :label="option.text"
                      :value="option.val"> </el-option>
                  </el-select>
                </div>
              </li>
              <li class="clearfix mar20_b">
                <div class="pull-left pad15_l pad30_r">
                  <div class="clearfix normal pad35_l">
                    <em class="red">*</em>短溢量(仅适用于大宗原料)：±
                    <el-input-number controls-position="right" size="small" :precision="2" :step="1" :min="0.01"
                      :max="100" class="border w80 mar5 dpad5" v-model="shortSpillover"
                      @change="inputNumberChange($event)"></el-input-number>%，在此范围内根据实际交货数量及本合同约定销售单价计算最终合同价款。
                  </div>
                  <div class="clear pad35_l paymethod">
                    <div class="clearfix  ">
                      <em
                        class="red">*</em>甲方逾期交付产品的，每逾期一天，应按照合同总价款的0.05%向乙方支付违约金，逾期超过5天的，则乙方有权解除合同，且甲方应当全额退还乙方已经支付的合同价款。
                    </div>
                    <div class="box10"></div>
                    <div class="clearfix  ">
                      <em class="red">*</em>乙方逾期付款的，每逾期一天，应按照合同未付款的0.05%向甲方支付违约金。
                    </div>
                    <div class="box10"></div>
                    <div class="clearfix  ">
                      <em class="red">*</em>乙方应在当批次货物收货后
                      <el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1"
                        :max="15" class="border w60 mar5 dpad5" v-model="secondPartyInspectionDays"
                        @change="inputNumberChange($event)"></el-input-number>日内在平台上确认收货，逾期未确认收货的，平台在甲方提供相关交货证明后自动将该批次对应货款划给甲方。
                    </div>
                    <div class="box10"></div>
                    <div class="clearfix  ">
                      <em class="red">*</em>产品到达收货地点后，采用火车或轮船运输的乙方应在存放方通知或要求的可免费存放并提货时间内，采用汽车运输的乙方应在到货后
                      <el-input-number controls-position="right" size="small" :precision="0" :step="1" :min="1"
                        :max="15" class="border w80 mar5 dpad5" v-model="motorTransportInspectionDays"
                        @change="inputNumberChange($event)"></el-input-number>日内，由乙方按双方按约定的包装和质量标准进行验收。
                    </div>
                    <div class="box10"></div>
                    <div class="clearfix  ">
                      <em class="red">*</em>乙方有异议的应在验收后<el-input-number controls-position="right" size="small"
                        :precision="0" :step="1" :min="1" :max="15" class="border w80 mar5 dpad5"
                        v-model="motorTransportAcceptanceDays"
                        @change="inputNumberChange($event)"></el-input-number>日内以书面方式（含邮件）反馈给甲方或甲方上游供应商，否则视为所交付产品符合约定并完成交。
                    </div>
                    <div class="box10"></div>
                    <div class="clearfix  ">
                      <em class="red">*</em>甲方应在收到全部款项后，向乙方开具合法增值税普通发票。
                    </div>
                    <div>
                      <span style="color: #7F7F7F;background-color: #F4F4F4">此条款仅与平台方进行交易时有效，并进行展示</span>
                    </div>
                  </div>
                </div>
              </li>
            </template>
          </ul>
          <ul>
            <li class="clearfix mar20_b pad35_l">
              <div class="pull-left pad15_l pad30_r">
                <div class="box10"></div>
                <div class="clearfix normal pad30_l">
                  <label class="pad10_r block normal">双方对赔付拒收标准的特别约定</label>
                  <el-input style="width: 500px" type="textarea" placeholder="请输入内容"
                    v-model="twoPartyRejectionAppointment" :maxlength="200" show-word-limit></el-input>
                </div>
                <div class="clearfix normal pad30_l">
                  <label class="pad10_r block normal">双方对违约责任的特别约定</label>
                  <el-input style="width: 500px" type="textarea" placeholder="请输入内容"
                    v-model="twoPartyFalsifyAppointment" :maxlength="200" show-word-limit></el-input>
                </div>
                <div class="clearfix pad30_l">
                  <label class="pad10_r block normal">电子合同补充条款</label>
                  <el-input style="width: 500px" type="textarea" placeholder="请输入内容" v-model="contractSupplement"
                    :maxlength="200" show-word-limit></el-input>
                </div>
              </div>
            </li>
          </ul>
        </template>




      </div>
      <div class="mar20-t text-center">
        <el-button type="primary" :disabled="isSubmitSave" @click="save">保存</el-button>
      </div>
      <div class="con-box50"></div>
    </template>
    <el-empty v-if="!alertEditbox" :description="alertEditMsg">
      <el-button type="primary" @click="callback">返回列表</el-button>
    </el-empty>
  </div>
</template>

<style>
  .el-textarea__inner {
    height: 100px;
  }

  .el-button--primary {
    color: #FFFFFF;
    background-color: #1890ff;
    border-color: #1890ff;
  }

  .el-button--primary:active {
    background: #1890ff;
    border-color: #1890ff;
    color: #FFFFFF;
    outline: none;
  }

  .el-button--primary:hover,
  .el-button--primary:focus {
    background: #1890ff;
    border-color: #1890ff;
    color: #FFFFFF;
  }

  .el-button--primary.is-disabled,
  .el-button--primary.is-disabled:hover,
  .el-button--primary.is-disabled:focus,
  .el-button--primary.is-disabled:active {
    color: #FFFFFF;
    background-color: rgba(24, 144, 255, 0.68);
    border-color: #1890ff;
  }
</style>
<style lang="scss" scoped>
  @import "./detail.scss";
</style>

<script type="text/javascript">
  import request from "@/utils/request";
  import qs from "qs";

  export default {
    name: "ContractDetail",

    data() {
      return {
        loaded: false,
        isSubmit: true,
        loading: true,

        //合同类型集合
        contractTemplateList: ["SHEBEI_CONTRACT", "PT-PTKH", "CG-NXKH", "XS-PTKH", "VIP_CONTRACT", "ZY-NXKH",'CG-KLMY','XS-KLMY','CG-YR','XS-YR'],
        contractTemplateTypeList: [
          {
            val: "SHEBEI_CONTRACT",
            text: "设备销售",
          }
        ],
        //合同模板类型集合
        templateMethodList: [
          {
            val: "PT-PTKH",
            text: "乙方（买方）为普通客户",
          },
          {
            val: "CG-NXKH",
            text: "乙方（买方）为农信",
          },
          {
            val: "CG-KLMY",
            text: "乙方（买方）为克拉玛依",
          },
          {
            val: "CG-YR",
            text: "乙方（买方）为裕融",
          }
        ],
        //支付方式集合（供应商-普通客户）
        paymentMethodList: [
          {
            val: "多次支付",
            text: "多次支付,2,10,80,2,10,3",
          },
          {
            val: "先款后货",
            text: "先款后货,2,3",
          },
          {
            val: "先货后款",
            text: "先货后款,3,2",
          }
        ],
        //支付方式集合（供应商-农信客户）
        paymentMethodNXList: [
          {
            val: "1",
            name: "订单或批次先款后货",
            text: "1,2,3",
          },
          {
            val: "2",
            name: "按订单或批次货到付款(A)",
            text: "2,3,2",
          },
          {
            val: "3",
            name: "按订单或批次货到付款(B)",
            text: "3,3,2",
          },
          {
            val: "4",
            name: "分次付款",
            text: "4,2,10,80,2,10,3,10",
          }
        ],
        //支付方式集合（农信-客户）
        paymentMethodPTList: [
          {
            val: "1",
            name: "先款后货",
            text: "1,2,3",
          },
          {
            val: "2",
            name: "货到付款",
            text: "2,3,2",
          },
          {
            val: "4",
            name: "多次支付",
            text: "4,2,10,80,2,10,3,10",
          }
        ],
        //VIP支付方式集合
        paymentMethodVipList: [
          {
            val: "A",
            name: "固定收费",
          },
          {
            val: "B",
            name: "按养殖规模收费",
          }
        ],
        //运输方式集合
        transportModeList: [
          {
            val: "汽运",
            text: "汽运",
          },
          {
            val: "火运",
            text: "火运",
          },
          {
            val: "船运",
            text: "船运",
          },
          {
            val: "物流",
            text: "物流",
          }
        ],
        //安装方式集合
        installTransportModeList: [
          {
            val: "1",
            text: "甲方依照乙方提供的设备自行安装，乙方或乙方上游供应商仅提供远程技术指导",
          },
          {
            val: "2",
            text: "甲方负责安装，乙方或乙方上游供应商派技术人员前往现场进行技术指导，协助甲方",
          },
          {
            val: "3",
            text: "乙方或乙方上游供应商派技术人员前往现场进行安装，甲方提供必要的现场协助。甲方需向乙方支付相应的差旅以及人工费用，前述费用据实核算",
          }
        ],
        //运费承担集合（供应商-普通客户）
        freightBearList: [
          {
            val: "卖家",
            text: "卖家",
          },
          {
            val: "买家",
            text: "买家",
          }
        ],
        //运费承担集合（供应商-农信客户）
        freightBearNXList: [
          {
            val: "甲方",
            text: "甲方",
          },
          {
            val: "乙方下游客户",
            text: "乙方下游客户",
          }
        ],
        //运费承担集合（农信-客户）
        freightBearPTList: [
          {
            val: "乙方",
            text: "乙方",
          },
          {
            val: "甲方上游供应商",
            text: "甲方上游供应商",
          }
        ],
        //诉讼所在地集合
        lawsuitLocationList: [
          {
            val: "合同签订地",
            text: "合同签订地",
          },
          {
            val: "合同履行地",
            text: "合同履行地",
          },
          {
            val: "原告住所地",
            text: "原告住所地",
          },
          {
            val: "被告所在地",
            text: "被告所在地",
          },
          {
            val: "甲方所在地",
            text: "甲方所在地",
          },
          {
            val: "乙方所在地",
            text: "乙方所在地",
          },
        ],
        //支付方式
        paymentMethodValue: [],
        //支付方式
        paymentMethodNXValue: [],
        //支付方式
        paymentMethodPTValue: [],
        //支付方式
        paymentMethodSheBeiValue: [1, 2, 5, 5],
        //支付方式
        paymentMethodVipValue: "A",
        //合同模板类型
        templateMethodSel: "",
        //合同类型
        contractTemplateTypeSel: "",
        //运输方式
        transportModeSel: "",
        //安装方式
        installTransportModeSel: "",
        //运费承担（供应商-普通客户）
        freightBearSel: "",
        //运费承担（供应商-农信客户）
        freightBearNXSel: "",
        //运费承担（农信-客户）
        freightBearPTSel: "",
        //诉讼所在地
        lawsuitLocationSel: "",
        paymentMode: "", //支付方式-已选择
        paymentModeNX: "", //支付方式-已选择
        paymentModePT: "", //支付方式-已选择
        transportMode: "", //运输方式-已选择
        freightBear: "", //运费承担-已选择
        lawsuitLocation: "", //诉讼所在地-已选择

        shopAttr: {},
        name: '',
        shortSpillover: "", //短溢量
        firstPartyFalsifyRate: "", //甲方向乙方支付违约金
        secondPartyFalsifyRate: "", //乙方向甲方支付违约金
        secondPartyInspectionDays: "", //乙方在平台上确认收货
        platformAdvanceDays: "",
        twoPartyRejectionAppointment: "",
        twoPartyFalsifyAppointment: "",
        contractSupplement: "",
        isDataChanges: false,
        motorTransportInspectionDays: "",
        motorTransportAcceptanceDays: "",
        notInvoicedAmountRate: "",
        specialQualityAgreement: "",
        invoicingDays: "",
        replacementDays: "",
        secondPartyFalsifyDays: "",
        firstPartyFalsifyDays: "",


        attrId: "",
        transferAttrId: false,
        isReadMsg: '',
        alertEditbox: true,
        alertEditMsg: "",
        templateMode: "",
        shopId: "",
        isSubmitSave: false,
        isDefault: false,

        // 代销合同属性
        attrVal: {},
      };
    },
    created() {
      this.templateMode = this.$route.query.templateMode;
      if (this.templateMode == "") {
        this.alertEditbox = false;
        this.alertEditMsg = "合同模板不存在！";
        return;
      }
      const contractItemArr = this.contractTemplateList.filter((contractItem) => contractItem == this.templateMode);
      if (contractItemArr.length == 0) {
        this.alertEditbox = false;
        this.alertEditMsg = "合同模板有误！";
        return;
      }
      this.attrId = this.$route.query.attrId;
      if (this.attrId && this.attrId != 0) {
        this.transferAttrId = true;
      }
      this.shopId = this.$route.query.shopId;
      this.templateMode = this.$route.query.templateMode;
      this.query();
    },
    methods: {
      query() {
        request
          .get(`${process.env.VUE_APP_APP}mj/toContractInfo?shopId=${this.shopId}&attrId=${this.attrId}&templateMode=${this.templateMode}`)
          .then((res) => {
            this.loaded = true;
            if (res.isRead == "1") {
              this.alertEditbox = false;
              this.alertEditMsg = res.isReadMsg;
              return;
            }
            if (res.shopAttr != null) {
              this.shopAttr = res.shopAttr;
              this.attrId = res.shopAttr.attrId;
              this.name = res.shopAttr.name;
              this.isDefault = res.shopAttr.isDefault == '1' ? true : false;
            }

            //this.templateMethodSel = this.shopAttr.templateMode ? this.shopAttr.templateMode : $("#isSelfOperatedShop").val() == "1" ? "XS-PTKH" : this.templateMethodList[0].val;
            this.templateMethodSel = this.shopAttr.templateMode ? this.shopAttr.templateMode : this.templateMode;
            this.contractTemplateTypeSel = this.shopAttr.templateMode ? this.shopAttr.templateMode : this.templateMode;

            this.transportModeSel = this.shopAttr.transportMode ? this.shopAttr.transportMode : this.transportModeList[0].val;
            this.installTransportModeSel = this.shopAttr.transportMode ? this.shopAttr.transportMode : this.installTransportModeList[0].val;

            this.freightBearSel = this.shopAttr.freightBear ? this.shopAttr.freightBear : this.freightBearList[0].val;
            this.freightBearNXSel = this.shopAttr.freightBear ? this.shopAttr.freightBear : this.freightBearNXList[0].val;
            this.freightBearPTSel = this.shopAttr.freightBear ? this.shopAttr.freightBear : this.freightBearPTList[0].val;

            this.lawsuitLocationSel = this.shopAttr.lawsuitLocation ? this.shopAttr.lawsuitLocation : this.lawsuitLocationList[0].val;

            this.paymentMethodValue = this.shopAttr.paymentMode ? this.shopAttr.paymentMode.split(",") : this.paymentMethodList[0].text.split(",");
            this.paymentMethodNXValue = this.shopAttr.paymentMode ? this.shopAttr.paymentMode.split(",") : this.paymentMethodNXList[0].text.split(",");
            this.paymentMethodPTValue = this.shopAttr.paymentMode ? this.shopAttr.paymentMode.split(",") : this.paymentMethodPTList[0].text.split(",");
            this.paymentMethodSheBeiValue = this.shopAttr.paymentMode ? this.shopAttr.paymentMode.split(",") : this.paymentMethodSheBeiValue;
            this.paymentMethodVipValue = this.shopAttr.paymentMode ? this.shopAttr.paymentMode.split(",")[0] : "A";

            this.shortSpillover = this.shopAttr.shortSpillover || '5';
            this.firstPartyFalsifyRate = this.shopAttr.firstPartyFalsifyRate || '0.25';
            this.secondPartyFalsifyRate = this.shopAttr.secondPartyFalsifyRate || '0.25';
            this.secondPartyInspectionDays = this.shopAttr.secondPartyInspectionDays || '2';
            this.platformAdvanceDays = this.shopAttr.platformAdvanceDays || '3';
            this.twoPartyRejectionAppointment = this.shopAttr.twoPartyRejectionAppointment || "";
            this.specialQualityAgreement = this.shopAttr.specialQualityAgreement || "";
            this.twoPartyFalsifyAppointment = this.shopAttr.twoPartyFalsifyAppointment || "";
            this.contractSupplement = this.shopAttr.contractSupplement || "";
            this.motorTransportInspectionDays = this.shopAttr.motorTransportInspectionDays || '7';
            this.motorTransportAcceptanceDays = this.shopAttr.motorTransportAcceptanceDays || '7';
            this.notInvoicedAmountRate = this.shopAttr.notInvoicedAmountRate || '0.25';
            this.invoicingDays = this.shopAttr.invoicingDays || '3';
            this.replacementDays = this.shopAttr.replacementDays || '7';
            this.secondPartyFalsifyDays = this.shopAttr.secondPartyFalsifyDays || '15';
            this.firstPartyFalsifyDays = this.shopAttr.firstPartyFalsifyDays || '5';
            this.attrVal = this.shopAttr.attrVal ? JSON.parse(this.shopAttr.attrVal) : {};
          })
          .catch(() => {
            this.loaded = true;
            this.$message.error("修改失败");
          });
      },
      paymentMethodSel() {
        if (!(this.shopAttr.paymentMode == undefined || this.shopAttr.paymentMode == '') && this.paymentMethodValue[0] == this.shopAttr.paymentMode.split(",")[0]) {
          this.paymentMethodValue = this.shopAttr.paymentMode.split(",");
          return;
        }
        this.paymentMethodList.forEach(function (item) {
          if (item.val == this.paymentMethodValue[0]) {
            this.paymentMethodValue = item.text.split(",");
          }
        })
      },
      paymentMethodNXSel() {
        if (!(this.shopAttr.paymentMode == undefined || this.shopAttr.paymentMode == '') && this.paymentMethodNXValue[0] == this.shopAttr.paymentMode.split(",")[0]) {
          this.paymentMethodNXValue = this.shopAttr.paymentMode.split(",");
          return;
        }
        this.paymentMethodNXList.forEach(function (item) {
          if (item.val == this.paymentMethodNXValue[0]) {
            this.paymentMethodNXValue = item.text.split(",");
          }
        })
      },
      paymentMethodPTSel() {
        if (!(this.shopAttr.paymentMode == undefined || this.shopAttr.paymentMode == '') && this.paymentMethodPTValue[0] == this.shopAttr.paymentMode.split(",")[0]) {
          this.paymentMethodPTValue = this.shopAttr.paymentMode.split(",");
          return;
        }
        this.paymentMethodPTList.forEach((item) => {
          if (item.val == this.paymentMethodPTValue[0]) {
            this.paymentMethodPTValue = item.text.split(",");
          }
        })
      },
      inputNumberChange(val) {
        if (val == undefined || val == "") {
          this.isSubmitSave = true;
        } else {
          this.isSubmitSave = false;
        }
      },
      save: function () {
        if (this.name == "") {
          alert("请填写合同模板名称");
          return;
        }
        this.$confirm('是否确认保存?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var paymentMethodValue = this.paymentMethodValue.toLocaleString();
          var freightBearSel = this.freightBearSel;
          if (this.templateMethodSel == 'CG-NXKH'|| this.templateMethodSel == 'CG-KLMY'|| this.templateMethodSel == 'CG-YR') {
            paymentMethodValue = this.paymentMethodNXValue.toLocaleString();
            freightBearSel = this.freightBearNXSel;
          } else if (this.templateMethodSel == 'XS-PTKH') {
            paymentMethodValue = this.paymentMethodPTValue.toLocaleString();
            freightBearSel = this.freightBearPTSel;
          } else if (this.templateMethodSel == 'SHEBEI_CONTRACT') {
            paymentMethodValue = this.paymentMethodSheBeiValue.toLocaleString();
            this.transportModeSel = this.installTransportModeSel;
          } else if (this.templateMethodSel == 'VIP_CONTRACT') {
            paymentMethodValue = this.paymentMethodVipValue.toLocaleString() + ", 1";
          }
          let saveAttrId = this.attrId;
          // 新增时attrId = 0
          if (!this.transferAttrId) {
            saveAttrId = 0;
          }
          request
            .post(`${process.env.VUE_APP_APP}mj/addContractInfo`, qs.stringify({
              shopId: this.shopId,
              transportMode: this.transportModeSel,
              templateMode: this.templateMethodSel,
              freightBear: freightBearSel,
              lawsuitLocation: this.lawsuitLocationSel,
              shortSpillover: this.shortSpillover,
              firstPartyFalsifyRate: this.firstPartyFalsifyRate,
              secondPartyFalsifyRate: this.secondPartyFalsifyRate,
              secondPartyInspectionDays: this.secondPartyInspectionDays,
              platformAdvanceDays: this.platformAdvanceDays,
              twoPartyRejectionAppointment: this.twoPartyRejectionAppointment,
              twoPartyFalsifyAppointment: this.twoPartyFalsifyAppointment,
              contractSupplement: this.contractSupplement,
              motorTransportInspectionDays: this.motorTransportInspectionDays,
              motorTransportAcceptanceDays: this.motorTransportAcceptanceDays,
              notInvoicedAmountRate: this.notInvoicedAmountRate,
              specialQualityAgreement: this.specialQualityAgreement,
              invoicingDays: this.invoicingDays,
              paymentMode: paymentMethodValue,
              attrId: saveAttrId,
              name: this.name,
              replacementDays: this.replacementDays,
              secondPartyFalsifyDays: this.secondPartyFalsifyDays,
              firstPartyFalsifyDays: this.firstPartyFalsifyDays,
              attrVal: JSON.stringify(this.attrVal),
            }))
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("保存成功");
                this.attrId = res.data;
                //this.query();
                window.location.href = `${process.env.VUE_APP_APP}v/mj/contract?appid=1&isShowTitle=1`
              } else {
                this.$message.error(res.error);
              }
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消保存'
          });
        });
      },
      callback() {
        if (self != top) {
          /*window.parent.postMessage(
            { fn: "open", data: { url: `${process.env.VUE_APP_APP}v/mj/contract?appid=1&isShowTitle=1`, title: "合同设置", target: 0 } },
            "*"
          );*/
          window.parent.postMessage({ fn: "close", data: { url: `${process.env.VUE_APP_APP}v/mj/contract/detail`, title: "", target: 0 } }, "*");
        } else {
          window.open(`${process.env.VUE_APP_APP}v/mj/contract?appid=1&isShowTitle=1`);
        }
      }
    },
  };
</script>
